import React, { useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import ModellingAgency from './components/ModellingAgency';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import './App.css';

function App() {
  const [showAuth, setShowAuth] = useState(false);

  return (
    <AuthProvider>
      <div className="app">
        <Header onAuthClick={() => setShowAuth(true)} />
        <main>
          <Hero />
          <Products onAuthRequired={() => setShowAuth(true)} />
          <ModellingAgency />
          <ContactSection />
        </main>
        <Footer />
        <AuthModal isOpen={showAuth} onClose={() => setShowAuth(false)} />
      </div>
    </AuthProvider>
  );
}

export default App;
